
import { createReducer, on } from '@ngrx/store';
import { MyCreditCard } from '@libs/entity-lib';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as fromActions from './my-cards.actions';

export interface State extends EntityState<MyCreditCard> {
  loading: boolean;
  error: any | null;
  cardSelected?: MyCreditCard
}

const adapter: EntityAdapter<MyCreditCard> = createEntityAdapter<MyCreditCard>({
  selectId: (packageValue: MyCreditCard) => packageValue.id
});

export const initialState: State = adapter.getInitialState({
  error: null,
  loading: false
});

export const reducer = createReducer(
  initialState,
  on(fromActions.fetcMyCards, (state) =>  ({ ...state, loading: true, error: null })),
  on(fromActions.fetcMyCardsSuccessfully, (state, { myCards }) => {

    return adapter.upsertMany(myCards, {
      ...state,
      loading: false
    })
  }),
  on(fromActions.fetcMyCardsFailed, (state, { error }) =>  adapter.setAll([], { ...state, loading: false, error })),
  
  on(fromActions.deleteMyCard, (state) =>  ({ ...state, loading: true, error: null, cardSelected: undefined })),
  on(fromActions.deleteMyCardSuccessfuly, (state, { cardId }) => {

    return adapter.removeOne(cardId, {
      ...state,
      loading: false,
      cardSelected: undefined
    })
  }),
  on(fromActions.deleteMyCardFailed, (state, { error }) =>  ({ ...state, loading: false, error })),
  on(fromActions.setMyCreditCardSelected, (state, { card }) =>  ({ ...state, cardSelected: card })),
  on(fromActions.adddNewCard, (state) =>  ({ ...state, loading: true, error: null })),
  on(fromActions.addNewCardSuccessfuly, (state) =>  ({ ...state, loading: false, error: null })),
  on(fromActions.addNewCardFailed, (state, { error }) =>  ({ ...state, loading: false, error })),
);

export const { selectAll } = adapter.getSelectors();